import classNames from 'classnames'
import useTranslate from 'modules/local/useTranslate'
import React from 'react'
import {IoCheckmarkCircle} from 'react-icons/io5'
import {NullAsDefault} from 'views/Shared'

const WEEKDAY_LABELS = ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat']

// Dùng chung cho mọi trường hợp cần chọn ngày-trong-tuần lặp lại (timetable, giờ lễ...).
// value/onChange dùng chuỗi bitmask 7 ký tự '0'/'1' (CN -> T7), giữ tương thích format cũ.
export const WeekdaysField = ({value, defaultValue = '0000000', onChange = NullAsDefault}) => {
    const t = useTranslate()
    const weekdaysArray = (value || defaultValue).split('')
    const isAllSelected = weekdaysArray.join('') === '1111111'

    const toggleDay = (index) => {
        const next = [...weekdaysArray]
        next[index] = next[index] === '1' ? '0' : '1'
        onChange(next.join(''))
    }

    const toggleAll = () => {
        onChange(isAllSelected ? '0000000' : '1111111')
    }

    return (
        <div className="flex flex-wrap items-center gap-2">
            {WEEKDAY_LABELS.map((label, index) => {
                const isActive = weekdaysArray[index] === '1'
                return (
                    <button
                        type="button"
                        key={index}
                        onClick={() => toggleDay(index)}
                        style={{width: 44, height: 44}}
                        className={classNames(
                            'flex flex-center rounded-full font-bold text-xs uppercase border-2 transition-all cursor-pointer',
                            isActive
                                ? 'bg-primary border-primary text-white shadow-md'
                                : 'background-100 border-transparent text-color-200 hover:border-primary-200 hover:text-primary-500'
                        )}>
                        {t(label)}
                    </button>
                )
            })}
            <button
                type="button"
                onClick={toggleAll}
                style={{minHeight: 44}}
                className={classNames(
                    'flex flex-center gap-1 px-3 rounded-full font-semibold text-xs border transition-colors cursor-pointer',
                    isAllSelected
                        ? 'bg-primary-50 border-primary-300 text-primary-700'
                        : 'border-dashed border-color-200 text-color-300 hover:border-primary-300 hover:text-primary-500'
                )}>
                {isAllSelected && <IoCheckmarkCircle size={14} className="flex-shrink-0"/>}
                {t('everyday')}
            </button>
        </div>
    )
}
